// extracted by mini-css-extract-plugin
export default {"timelineContainer":"AcademicTimeline_timelineContainer__-XTJC","timelineImage":"AcademicTimeline_timelineImage__iVJeL"};